export default "__VITE_ASSET__C08NS5oL__"